module.exports = __webpack_public_path__ + "media/images/menu/gallery-bf40162e25a884f314129afb2e5fc994.jpg";